import {ITheme} from 'contexts/ThemeContext';
import {StyleSheet, useWindowDimensions} from 'react-native';

export default (props: ITheme) => {
  const width = useWindowDimensions().width;

  return StyleSheet.create({
    defaultContainerStyle: {
      flex: 1,
      backgroundColor: props.colors.transparentPrimary,
    },
    headerView: {
      flexGrow: 1,
      width: '100%',
      paddingLeft: 15,
      paddingRight: 15,
      paddingTop: 5,
    },
    calendarStyle: {
      borderRadius: 13,
    },
    jumpToDateContainer: {
      marginTop: 10,
      width: '100%',
    },
    headerContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      flexGrow: 1,
      paddingTop: 10,
      paddingBottom: 5,
      width: '100%',
    },
    defaultModalWindowStyle: {
      alignSelf: 'center',
      width: width - 32,
      borderRadius: 13,
      backgroundColor: props.colors.white,
    },
  });
};
